import { PoseLandmark } from '../types';

/**
 * Calculates the angle between three points (A, B, C) where B is the vertex.
 * Returns angle in degrees (0-180).
 */
export const calculateAngle = (a: PoseLandmark, b: PoseLandmark, c: PoseLandmark): number => {
  const radians = Math.atan2(c.y - b.y, c.x - b.x) - Math.atan2(a.y - b.y, a.x - b.x);
  let angle = Math.abs((radians * 180.0) / Math.PI);

  if (angle > 180.0) {
    angle = 360.0 - angle;
  }
  return angle;
};

/**
 * Calculates Euclidean distance between two points.
 */
export const calculateDistance = (a: PoseLandmark, b: PoseLandmark): number => {
  return Math.hypot(a.x - b.x, a.y - b.y);
};